/**
 * Drill-down for a repeatable_array cell rendered with the "separate" strategy —
 * shows the nested entries as a sub-table (sub-fields = columns).
 */
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from '@/components/ui/dialog'
import { formatCellValue } from '../lib/value-format'
import type { CatalogField } from '../lib/column-catalog'

interface ArrayDetailDialogProps {
  open: boolean
  onOpenChange: (o: boolean) => void
  title: string
  field: CatalogField | undefined
  entries: unknown[]
}

export function ArrayDetailDialog({ open, onOpenChange, title, field, entries }: ArrayDetailDialogProps) {
  const subs = field?.subFields ?? []
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        <div className="overflow-auto max-h-[60vh]">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="bg-muted">
                <th className="px-3 py-2 text-start text-xs font-semibold text-muted-foreground">#</th>
                {subs.map((s) => (
                  <th key={s.fieldKey} className="px-3 py-2 text-start text-xs font-semibold text-muted-foreground whitespace-nowrap">{s.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(entries as Record<string, unknown>[]).map((entry, i) => (
                <tr key={i} className="border-b border-border">
                  <td className="px-3 py-2 text-muted-foreground tabular-nums">{i + 1}</td>
                  {subs.map((s) => (
                    <td key={s.fieldKey} className="px-3 py-2 text-foreground">{formatCellValue(s, entry?.[s.fieldKey])}</td>
                  ))}
                </tr>
              ))}
              {entries.length === 0 && (
                <tr><td colSpan={subs.length + 1} className="px-3 py-6 text-center text-muted-foreground">موردی نیست</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </DialogContent>
    </Dialog>
  )
}
